import { render, staticRenderFns } from "./shrinkable-menu.vue?vue&type=template&id=65a1be94&scoped=true&"
import script from "./shrinkable-menu.vue?vue&type=script&lang=ts&"
export * from "./shrinkable-menu.vue?vue&type=script&lang=ts&"
import style0 from "./shrinkable-menu.vue?vue&type=style&index=0&id=65a1be94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1be94",
  null
  
)

export default component.exports